var card_viewer_default = {
  "cardWrapper": "-iuzK",
  "cardContainer": "bn-GI",
  "cardContent": "wdqj1",
  "pageSeparator": "Vf5ZS",
  "fluid": "_8QqBw",
  "print": "nB58e"
};
export {
  card_viewer_default as default
};
//# sourceMappingURL=card-viewer-scss.js.map
